<template>
  <div id="app" :class="{ 'with-header': loggedIn }">
    <Header v-if="loggedIn"/>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/dashboard/Header.vue';
import AuthService from '@/service/auth/authService';
import actions from '@/config/actions';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: { Header },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
    }),
    loggedIn() {
      const isAuthenticated = AuthService.isLoggedIn() || Boolean(this.token);
      const isGuestRoute = this.$route.meta && this.$route.meta.guest;
      const isLogoutRoute = this.$route.name === 'logout';
      return isAuthenticated && !isGuestRoute && !isLogoutRoute;
    },
  },
  mounted() {
    if (AuthService.isLoggedIn() && !this.token) {
      this.$store.dispatch(actions.auth.LOGGED_IN, {});
      this.$store.dispatch('loadCurrentUser');
    }
  },
};
</script>

<style>
  #app {
    height: 100%;
  }
  
  #app.with-header {
    padding-top: 78px; /* Default for larger screens */
  }

  /* For 1366x768 and similar resolutions */
  @media (max-width: 1440px) {
    #app.with-header {
      padding-top: 90px;
    }
  }

  @media (max-width: 1366px) {
    #app.with-header {
      padding-top: 95px;
    }
  }

  @media (max-width: 1280px) {
    #app.with-header {
      padding-top: 100px;
    }
  }

  @media (max-width: 1200px) {
    #app.with-header {
      padding-top: 105px;
    }
  }

  @media (max-width: 992px) {
    #app.with-header {
      padding-top: 110px;
    }
  }

  @media (max-width: 768px) {
    #app.with-header {
      padding-top: 120px;
    }
  }
</style>
